export const SHOW_ALERT = "Show Alert";
export const HIDE_ALERT = "Hide Alert";
export const NAVURL = "Navigate";
export const INITIATE_COMMON = "Initiate Common";
export const SET_MENU_TREE = "Set Menu Tree";
export const FLUSH_MENU_TREE = "Flush Menu Tree";
export const FLUSH_COMMON_OBJECT = "Flush Common Object";
export const GET_CURRENT_MENU_TREE = "Get Current Menu Tree";
export const NAVIGATE_TO_DEFAULT_PAGE = "Navigate To Default Page";
export const SHOW_LOADER = "SHOW_LOADER";
export const HIDE_LOADER = "HIDE_LOADER";
export const UPDATE_USER_CONFIGURATION = "UPDATE_USER_CONFIGURATION";
export const SET_ORGANIZATIONS = "SET_ORGANIZATIONS";
export const SET_USER_TYPE = "SET_USER_TYPE";